import { createContext, FC, useContext } from 'react';
import { PolicyConfiguration } from '../../types/PolicyConfiguration';
import { useGetRulesData } from '../../api';

interface PolicyConfigurationContextType {
    policyConfiguration?: PolicyConfiguration;
    loading: boolean;
    error?: unknown;
}

export const PolicyConfigurationContext = createContext<PolicyConfigurationContextType | undefined>(undefined);

export const PolicyConfigurationProvider: FC = ({ children }) => {
    const { rulesData, loading, error } = useGetRulesData();

    return (
        <PolicyConfigurationContext.Provider
            value={{
                policyConfiguration: rulesData?.PolicyConfiguration,
                loading,
                error
            }}>
            {children}
        </PolicyConfigurationContext.Provider>
    );
};

export const usePolicyConfigurationContext = () => {
    const context = useContext(PolicyConfigurationContext);

    if (!context) {
        throw new Error(
            'PolicyConfigurationContext not initialized, please make sure you use it under `PolicyConfigurationContext.Provider`.'
        );
    }

    return context;
};
